{
  "frame": {
    "step": "Step {n} of {total}",
    "back": "Back",
    "continue": "Continue",
    "loading": "Getting things ready",
    "more": "More"
  },
  "caddie": {
    "title": "Choose your caddie",
    "lead": "Your caddie helps you set up, and talks you through each week.",
    "choose": "Choose {name}",
    "pick_first": "Pick a caddie first.",
    "families": "Voices",
    "portrait": "{name}, caddie",
    "portrait_note": "Drawn by the game. The final pictures are still to be approved.",
    "family": {
      "english": "English",
      "scottish": "Scottish",
      "irish": "Irish",
      "welsh": "Welsh",
      "american": "American",
      "australian": "Australian"
    },
    "lean": {
      "plan": "Likes a plan",
      "weather": "Reads the weather",
      "bounce_back": "Helps you bounce back",
      "routine": "Keeps your routine",
      "numbers": "Loves the numbers",
      "commit": "Backs your choices"
    },
    "who": {
      "caddie_nell": {
        "name": "Nell Ashby",
        "line": "Practical, organised, encouraging, with a dry wit.",
        "phrase": "Fairway first, fireworks later."
      },
      "caddie_tamsin": {
        "name": "Tamsin Rook",
        "line": "Brisk, outdoorsy and quietly sure.",
        "phrase": "Feel the air before you pick the club."
      },
      "caddie_reg": {
        "name": "Reg Cottam",
        "line": "Gentle, patient and full of stories.",
        "phrase": "Every round has a bad bit. Walk through it."
      },
      "caddie_priya": {
        "name": "Priya Holloway",
        "line": "Calm, kind and exact about habits.",
        "phrase": "Set up the same and the swing follows."
      },
      "caddie_alfie": {
        "name": "Alfie Brindle",
        "line": "Keen, quick, and loves a chart.",
        "phrase": "Aim where the numbers are kind."
      },
      "caddie_gaz": {
        "name": "Gaz Felton",
        "line": "Upbeat, with a big laugh. All in.",
        "phrase": "Pick it, back it, hit it."
      },
      "caddie_isla": {
        "name": "Isla Kinnaird",
        "line": "Thoughtful, precise and wry.",
        "phrase": "Play the hole the way it was drawn."
      },
      "caddie_dougie": {
        "name": "Dougie Rennick",
        "line": "Dry wit, never flustered, reads the weather like a book.",
        "phrase": "Keep it low and let it roll."
      },
      "caddie_ewan": {
        "name": "Ewan Tullis",
        "line": "Warm, quick to grin, never down for long.",
        "phrase": "That's gone. The next one's ours."
      },
      "caddie_agnes": {
        "name": "Agnes Moffat",
        "line": "Unhurried, steady, firm but kind.",
        "phrase": "Slow hands, steady head."
      },
      "caddie_kirsty": {
        "name": "Kirsty Haldane",
        "line": "Dry, sharp and fond of the odds.",
        "phrase": "The odds like the middle."
      },
      "caddie_fraser": {
        "name": "Fraser Kilgour",
        "line": "Big-hearted, direct and competitive.",
        "phrase": "Decide once, then swing free."
      },
      "caddie_eamon": {
        "name": "Eamon Tierney",
        "line": "Patient and wise, a man of few words.",
        "phrase": "There's always a safe way round."
      },
      "caddie_roisin": {
        "name": "Róisín Keogh",
        "line": "Practical, wind-wise and cheerful.",
        "phrase": "Let the breeze do the work."
      },
      "caddie_shiv": {
        "name": "Siobhán \"Shiv\" Carrow",
        "line": "Chatty and warm, a gentle storyteller.",
        "phrase": "Leave it behind and walk on."
      },
      "caddie_cormac": {
        "name": "Cormac Whelan",
        "line": "Composed, encouraging and steady.",
        "phrase": "Same rhythm, start to finish."
      },
      "caddie_aoife": {
        "name": "Aoife Brannigan",
        "line": "Bright, curious and quick.",
        "phrase": "Small edges add up to a good card."
      },
      "caddie_dessie": {
        "name": "Dessie Fogarty",
        "line": "Funny, brave and big-hearted.",
        "phrase": "Swing it like you mean it."
      },
      "caddie_bethan": {
        "name": "Bethan Harries",
        "line": "Orderly, warm and quietly funny.",
        "phrase": "Plan the hole from the green back."
      },
      "caddie_idris": {
        "name": "Idris Bevan",
        "line": "Calm, weather-wise and dependable.",
        "phrase": "Watch the trees; they tell you the wind."
      },
      "caddie_ffion": {
        "name": "Ffion Gwilym",
        "line": "Lively and warm, a gentle storyteller.",
        "phrase": "New hole, new scene."
      },
      "caddie_gethin": {
        "name": "Gethin Pryce",
        "line": "Calm and steady, with kindly humour.",
        "phrase": "Same routine, every shot."
      },
      "caddie_nia": {
        "name": "Nia Probert",
        "line": "Precise, upbeat and plain-spoken.",
        "phrase": "Trust the pattern, not the hunch."
      },
      "caddie_rhodri": {
        "name": "Rhodri Parry",
        "line": "Relaxed, bold and smiling.",
        "phrase": "Commit like you're catching a wave."
      },
      "caddie_walt": {
        "name": "Walt Hendricks",
        "line": "Courteous, patient, knows every blade of grass.",
        "phrase": "Respect the hole and it'll respect you."
      },
      "caddie_lupe": {
        "name": "Lupe Navarro",
        "line": "Upbeat, sharp-eyed and never flustered.",
        "phrase": "Read the sky, then the yardage."
      },
      "caddie_marcus": {
        "name": "Marcus Odell",
        "line": "Encouraging, energetic and warm.",
        "phrase": "Next shot is the only shot."
      },
      "caddie_june": {
        "name": "June Okafor",
        "line": "Calm, clear and unshakeable.",
        "phrase": "Clear the noise, then go."
      },
      "caddie_dee": {
        "name": "Dee Castellano",
        "line": "Upbeat, precise, loves a percentage.",
        "phrase": "Trust the numbers, then trust your swing."
      },
      "caddie_tucker": {
        "name": "Tucker Brandt",
        "line": "Cheerful, bold and full of energy.",
        "phrase": "Full swing, full heart."
      },
      "caddie_margo": {
        "name": "Margo Pennington",
        "line": "Canny, kind and patient.",
        "phrase": "Line first, length second."
      },
      "caddie_col": {
        "name": "Col Treloar",
        "line": "Laid-back, weather-wise and dry.",
        "phrase": "The wind's on your side if you let it be."
      },
      "caddie_tash": {
        "name": "Tash Kowalski",
        "line": "Bubbly, resilient and competitive.",
        "phrase": "Shake it off and back yourself."
      },
      "caddie_bec": {
        "name": "Bec Hollis",
        "line": "Steady, reassuring and unflustered.",
        "phrase": "Breathe, look, swing."
      },
      "caddie_hamish": {
        "name": "Hamish Teo",
        "line": "Thoughtful, precise and warm.",
        "phrase": "Measure twice, swing once."
      },
      "caddie_jonno": {
        "name": "Jonno Keats",
        "line": "A cheeky optimist, relaxed but competitive underneath.",
        "phrase": "Commit to it and let it fly."
      }
    }
  },
  "path": {
    "title": "How do you want to start?",
    "lead": "Pick one. {caddieName} will help with the rest.",
    "this_is_you": "This is you",
    "week": "Your first week",
    "real_handicap": {
      "name": "From my real handicap",
      "suits": "For golfers who want to play as themselves.",
      "week": "You tell us your handicap. Your golfer starts there, a little rusty."
    },
    "beginner": {
      "name": "Complete beginner",
      "suits": "For anyone new to golf, or starting again.",
      "week": "Lots to learn, and you will see it improve fast."
    },
    "junior": {
      "name": "Junior",
      "suits": "For a young golfer, aged 8 to 15, with years to grow.",
      "week": "Junior events and lessons. Your golfer grows a year every half season."
    },
    "senior": {
      "name": "Senior (50+)",
      "suits": "For a golfer of 50 or more, with plenty of experience.",
      "week": "Steady form, and senior events from the start."
    },
    "random_life": {
      "name": "Random life",
      "suits": "For a surprise. The game picks a whole golf life for you.",
      "week": "You find out who your golfer is when you tee off."
    },
    "elite_amateur": {
      "name": "Elite amateur",
      "suits": "For a strong young golfer, aged 16 to 30.",
      "week": "You start in an amateur squad, with bigger events in reach."
    },
    "tour_pro": {
      "name": "Tour pro",
      "suits": "For a young professional, aged 18 to 35.",
      "week": "You start at Tour School and play the Regional Pro Series."
    }
  },
  "details": {
    "title": "A little more about your golfer",
    "age": "Age",
    "age_value": "{age} years old",
    "age_hint": "From {lo} to {hi}.",
    "handicap": "Your real-world handicap (self-declared)",
    "handicap_hint": "The handicap you play off today. Your golfer starts no better than {cap}.",
    "handicap_plus": "+{figure}",
    "handicap_error": "Type a handicap from +10.0 to 54.0, such as 11.2.",
    "senior_title": "How much have you played?",
    "senior": {
      "social_golfer": "A social golfer",
      "club_regular": "A club regular",
      "strong_club_player": "A strong club player"
    },
    "random_lead": "The game rolls a whole life for your golfer when you tee off: its age, its story and its start. You still choose the look and the name.",
    "junior_note": "A junior is always a made-up golfer. No real young person's details are asked for."
  },
  "game_quiz": {
    "title": "About your game",
    "lead": "Ten quick questions. They move your golfer's strengths around. They never make your golfer better or worse overall.",
    "progress": "Question {n} of {total}",
    "not_sure": "Not sure",
    "skip": "Skip the rest",
    "q": {
      "1": {
        "text": "How far do your good drives go, compared with golfers of your handicap?",
        "a0": "Shorter",
        "a1": "About average",
        "a2": "Longer",
        "a3": "One of the longest I play with"
      },
      "2": {
        "text": "How often do your tee shots finish in play?",
        "a0": "Rarely",
        "a1": "Sometimes",
        "a2": "Usually",
        "a3": "Almost always"
      },
      "3": { "text": "Your iron play is…", "a0": "My weakness", "a1": "Solid", "a2": "A strength" },
      "4": {
        "text": "When you miss a green, how often do you get up and down?",
        "a0": "Rarely",
        "a1": "Sometimes",
        "a2": "Often"
      },
      "5": {
        "text": "A greenside bunker makes you feel…",
        "a0": "Worried",
        "a1": "Fine",
        "a2": "Confident"
      },
      "6": {
        "text": "On the greens you are…",
        "a0": "I three-putt a lot",
        "a1": "Average",
        "a2": "A good putter",
        "a3": "The best putter I know"
      },
      "7": {
        "text": "Putts inside {distance}…",
        "a0": "I miss more than I should",
        "a1": "I hole most",
        "a2": "I almost never miss"
      },
      "8": {
        "text": "On a tight hole with trouble, you usually…",
        "a0": "Hit driver anyway",
        "a1": "It depends",
        "a2": "Take the safe club"
      },
      "9": {
        "text": "In wind and rain your game…",
        "a0": "Falls apart",
        "a1": "Holds up",
        "a2": "Gets relatively better"
      },
      "10": {
        "text": "Your scores from round to round are…",
        "a0": "All over the place",
        "a1": "Fairly steady",
        "a2": "Very steady"
      }
    }
  },
  "identity": {
    "title": "About your golfer",
    "gender": "Your golfer is",
    "male": "Male",
    "female": "Female",
    "nation": "Plays for",
    "club": "Home club",
    "club_hint": "Your golfer's club, in Yorkshire. More clubs come later.",
    "nations": {
      "eng": "England",
      "sco": "Scotland",
      "wal": "Wales",
      "irl": "Ireland",
      "usa": "United States"
    },
    "clubs": {
      "whinfell_heath": "Whinfell Heath",
      "ravensgarth_head": "Ravensgarth Head",
      "kettlewold_downs": "Kettlewold Downs",
      "langbeck_dale": "Langbeck Dale"
    }
  },
  "golfer": {
    "look": {
      "title": "Choose your golfer",
      "only_looks": "This changes how {golferName} looks on screen. It never changes a result.",
      "name": "Looks",
      "randomise": "Randomise",
      "head": {
        "body": "Body",
        "build": "Build",
        "skin_tone": "Skin tone",
        "hair": "Hair",
        "headwear": "Headwear",
        "eyewear": "Eyewear",
        "outfit": "Outfit",
        "colours": "Colours",
        "plays": "Plays"
      },
      "build": { "hint": "How your golfer is drawn. It changes nothing in play." },
      "plays": { "right": "Right-handed", "left": "Left-handed" },
      "more": "More",
      "free": "Everything here is free.",
      "change_later": "You choose these now. Changing them later, for free, comes in a later update.",
      "your_golfer": "your golfer"
    },
    "physique": {
      "build": { "hint": "How your golfer is made. This one changes how your golfer plays." }
    }
  },
  "look": {
    "turn": "Turn",
    "view": {
      "front": "Front",
      "side": "Side",
      "back": "Back"
    },
    "figure": "{golferName}, seen from the {view}",
    "open": "Change {row}",
    "done": "Done",
    "body": { "body_1": "Shape 1", "body_2": "Shape 2", "body_3": "Shape 3", "body_4": "Shape 4" },
    "builds": {
      "slim": "Slim",
      "average": "Average",
      "athletic": "Athletic",
      "broad": "Broad",
      "heavy": "Heavy"
    },
    "tone": "Tone {n}",
    "hair_colour": "Hair colour {n}",
    "hair_colours": "Hair colour",
    "hair": {
      "short": "Short",
      "crop": "Crop",
      "curls": "Curls",
      "afro": "Afro",
      "long": "Long",
      "bun": "Bun",
      "braids": "Braids",
      "bald": "Bald",
      "buzz": "Buzz cut",
      "locs": "Locs"
    },
    "headwear": {
      "none": "None",
      "cap": "Cap",
      "visor": "Visor",
      "bucket": "Bucket hat",
      "beanie": "Beanie",
      "sports_hijab": "Sports hijab",
      "patka": "Patka",
      "turban": "Turban"
    },
    "eyewear": { "none": "None", "glasses": "Glasses", "sunglasses": "Sunglasses" },
    "outfit": {
      "polo_trousers": "Polo and trousers",
      "polo_shorts": "Polo and shorts",
      "polo_skirt": "Polo and skirt",
      "jumper_trousers": "Jumper and trousers",
      "waterproof_trousers": "Waterproof and trousers"
    },
    "top": "Top",
    "bottom": "Trousers, shorts or skirt",
    "fabric": {
      "navy": "Navy",
      "green": "Green",
      "gold": "Gold",
      "sky": "Sky blue",
      "mist": "Grey",
      "red": "Red",
      "violet": "Violet",
      "aqua": "Aqua"
    },
    "face": { "title": "Face", "oval": "Oval", "round": "Round", "square": "Square" },
    "facial_hair": {
      "title": "Facial hair",
      "none": "None",
      "stubble": "Stubble",
      "beard": "Beard",
      "moustache": "Moustache"
    }
  },
  "build": {
    "title": "How your golfer is built",
    "height": "Height",
    "height_value": "{cm} cm",
    "build": "Build",
    "build_word": {
      "slight": "Slight",
      "lean": "Lean",
      "medium": "Medium",
      "solid": "Solid",
      "strong": "Strong"
    },
    "power": "Power or mobility",
    "power_hint": "Left for mobility, right for power.",
    "power_more": "More power by {n}",
    "mobility_more": "More mobility by {n}",
    "even": "Even",
    "drive_change": "Driver: about {distance} ({change})",
    "drive_even": "Driver: about {distance}",
    "consistency": {
      "lower": "Consistency: slightly lower",
      "same": "Consistency: the same",
      "higher": "Consistency: slightly higher"
    },
    "stamina": {
      "normal": "Stamina: normal",
      "tires_sooner": "Stamina: tires a little sooner"
    },
    "preview_note": "Worked out by the game's own engine against an average build."
  },
  "quiz": {
    "title": "What is {golferName} like?",
    "lead": "Twelve quick questions. Pick the answer that sounds most like your golfer.",
    "progress": "Question {n} of {total}",
    "q": {
      "1": {
        "text": "You three-putt the first green of the club championship. You…",
        "a0": "Smile. Seventeen holes to go.",
        "a1": "Stew for a hole, then birdie the next two.",
        "a2": "Head for the putting green after the round.",
        "a3": "Crack a joke with your playing partners."
      },
      "2": {
        "text": "You lead by one with three holes to play. Your hands feel…",
        "a0": "Rock steady. This is what I practise for.",
        "a1": "Shaky, but I trust my routine.",
        "a2": "Fine. Whatever happens, happens.",
        "a3": "Great. The crowd's loving it."
      },
      "3": {
        "text": "It's pouring with rain and your practice slot is booked. You…",
        "a0": "Go anyway. Waterproofs on.",
        "a1": "Swap to the gym and come back tomorrow.",
        "a2": "Rest. Tomorrow looks drier.",
        "a3": "Film a funny clip of the flooded bunker."
      },
      "4": {
        "text": "You've missed three cuts in a row. You…",
        "a0": "Remind yourself how well you're hitting it.",
        "a1": "Book extra sessions with your coach.",
        "a2": "Take a day off and come back fresh.",
        "a3": "Tell the local paper you'll bounce back."
      },
      "5": {
        "text": "A reporter asks about your bad round. You…",
        "a0": "Give an honest, thoughtful answer.",
        "a1": "Keep it short and get to the range.",
        "a2": "Make them laugh.",
        "a3": "Say tomorrow will be different, and mean it."
      },
      "6": {
        "text": "Your playing partner is painfully slow. You…",
        "a0": "Stay in your own bubble.",
        "a1": "Use the time to plan your next shot.",
        "a2": "Chat to keep things friendly.",
        "a3": "Let it go. It'll pass."
      },
      "7": {
        "text": "{distance} to win the monthly medal. You think…",
        "a0": "Knock it in.",
        "a1": "Same routine as every putt.",
        "a2": "If it misses, there's next month.",
        "a3": "Everyone's watching. Brilliant."
      },
      "8": {
        "text": "Your coach says your swing needs a big change. You…",
        "a0": "Start tomorrow, whatever it takes.",
        "a1": "Ask lots of questions first.",
        "a2": "Back yourself to pick it up quickly.",
        "a3": "Tell everyone about the new swing."
      },
      "9": {
        "text": "Your first tee shot goes out of bounds. You…",
        "a0": "Reload and hit a good one.",
        "a1": "Take a breath and reset.",
        "a2": "Shrug. It's a long round.",
        "a3": "\"Well, that's one way to start,\" you tell the group."
      },
      "10": {
        "text": "Your friends would call you…",
        "a0": "Calm",
        "a1": "Determined",
        "a2": "Unflappable when it matters",
        "a3": "The life of the party",
        "a4": "Hard to keep down"
      },
      "11": {
        "text": "A par 5 with water in front of the green; you have {distance}. You…",
        "a0": "Lay up to my favourite wedge.",
        "a1": "It depends how I'm playing.",
        "a2": "Go for it. That's why we play."
      },
      "12": {
        "text": "Your ideal round is…",
        "a0": "Fairways, greens, no drama.",
        "a1": "A few birdies, a few bogeys.",
        "a2": "Six birdies and a double. Exciting!"
      }
    },
    "summary": {
      "title": "{golferName} in a few words",
      "title_unnamed": "Your golfer in a few words",
      "all": "See all six",
      "retake": "Take the quiz again",
      "retake_hint": "You can take it once more, free, before you tee off.",
      "no_retake": "You have used your free retake."
    },
    "trait": {
      "temperament": {
        "name": "Temperament",
        "b0": "Quick to boil",
        "b1": "Can get wound up",
        "b2": "Even-tempered",
        "b3": "Calm",
        "b4": "Ice cool"
      },
      "work_ethic": {
        "name": "Work ethic",
        "b0": "Would rather play than practise",
        "b1": "Practises now and then",
        "b2": "Puts the work in",
        "b3": "Works hard",
        "b4": "Never stops working"
      },
      "bottle": {
        "name": "Nerve",
        "b0": "Feels the pressure",
        "b1": "Nervy at the finish",
        "b2": "Copes with pressure",
        "b3": "Steady under pressure",
        "b4": "Loves the big moment"
      },
      "charisma": {
        "name": "Charisma",
        "b0": "Keeps to themselves",
        "b1": "Quiet",
        "b2": "Friendly",
        "b3": "Good company",
        "b4": "The life of the party"
      },
      "resilience": {
        "name": "Resilience",
        "b0": "Bad holes linger",
        "b1": "Slow to bounce back",
        "b2": "Bounces back",
        "b3": "Hard to keep down",
        "b4": "Never beaten"
      },
      "style": {
        "name": "Playing style",
        "b0": "Plays it very safe",
        "b1": "Careful",
        "b2": "Balanced",
        "b3": "Bold",
        "b4": "Goes for everything"
      }
    }
  },
  "curve": {
    "title": "Which way does {golferName}'s usual shot curve?",
    "lead": "None is better than another. Your golfer's own curve costs nothing to play.",
    "left": "A gentle curve to the left",
    "straight": "No curve either way",
    "right": "A gentle curve to the right",
    "word": { "draw": "Draw", "fade": "Fade", "straight": "Straight" },
    "suggested": "Suggested",
    "picture": "A ball flight that {shape}",
    "shape": {
      "left": "curves gently to the left",
      "straight": "goes straight",
      "right": "curves gently to the right"
    }
  },
  "name": {
    "title": "Name your golfer",
    "check": "Check the name",
    "checking": "Checking the name",
    "free": "{display} is free to use.",
    "use": "Use {display}",
    "more_parts": "Add a middle initial, nickname or suffix",
    "fewer_parts": "Hide the extra name parts",
    "error": "We could not check the name just now. Try again.",
    "busy": "That was a lot of checks in a short time. Wait 10 minutes, then try again.",
    "admin": "This email is an admin account, so it cannot have a golfer. Open the game in a private window and save with a different email."
  },
  "review": {
    "title": "Ready to tee off?",
    "lead": "This is {golferName}. Check your choices, then tee off.",
    "path": "Start",
    "coins": "{coins, number} Coins to start",
    "coins_random": "Coins to start: shown when you tee off",
    "rust": "Rust: +{shots} shots. It wears off in about 2 to 3 weeks.",
    "curve": "Natural curve: {word}",
    "skills_after": "Your golfer's skills are drawn when you tee off. You see them straight away.",
    "details": "See all your choices",
    "hide_details": "Hide your choices",
    "change": "Change",
    "tee_off": "Tee off",
    "kit": {
      "starter_junior_half": "A junior half set",
      "starter_amateur_full": "A full amateur set",
      "starter_tour_ready": "A tour-ready set"
    },
    "row": {
      "caddie": "Caddie",
      "path": "Start",
      "age": "Age",
      "nation": "Plays for",
      "club": "Home club",
      "plays": "Plays",
      "height": "Height",
      "name": "Name",
      "curve": "Natural curve"
    }
  },
  "done": {
    "title": "{golferName} is ready",
    "lead": "Your golfer is made. Here is where they start.",
    "level": "Playing level",
    "potential": "Could reach about {best} to {worst}",
    "coins": "{coins, number} Coins",
    "areas": "See the 12 skill areas",
    "hide_areas": "Hide the skill areas",
    "name_waits": "We check every new name. Until then other players see a placeholder.",
    "next": "Go to Today"
  },
  "error": {
    "network": "We could not reach the game. Your choices are kept. Try again.",
    "try_again": "Try again",
    "signed_out": "Sign in to make your golfer. Your choices are kept on this phone.",
    "sign_in": "Save and sign in",
    "golfer_exists": "This account already has a golfer.",
    "name_taken": "Another golfer has just taken this name. Pick another.",
    "name_refused": "That name isn't allowed. Pick another.",
    "refused": "Something in your choices did not work. Check them and try again.",
    "albatross_required": "This start is for Albatross members. Pick another start.",
    "admin_account": "This email is an admin account, so it cannot have a golfer. Open the game in a private window and save with a different email."
  }
}
